export * from './SportBallTennisIcon';
export * from './SportBallTennisIcon16Light';
export * from './SportBallTennisIcon16Regular';
export * from './SportBallTennisIcon16Solid';
export * from './SportBallTennisIcon20Light';
export * from './SportBallTennisIcon20Regular';
export * from './SportBallTennisIcon20Solid';
export * from './SportBallTennisIcon24Regular';
export * from './SportBallTennisIcon24Solid';
export * from './SportBallTennisIcon32Regular';
export * from './SportBallTennisIcon64Regular';
